<template>
  <div class="header header-ct">
    <div class="logo-container">
      <img
        class="my-auto"
        src="/static/images/cds-logo.png"
        alt="CDS Global"
      >
    </div>
    <div class="header-main">
      <div
        v-show="clientSelected"
        class="selected-client-ct"
      >
        <b-link
          v-if="isAuthenticated && displayClientMsg"
          class="italic link-blue"
          @click="navigateToClientSelection"
        >
          {{ (clientSaved.text) ? clientSaved.text : "Please select a Publisher" }}
        </b-link>
      </div>
      <b-dropdown
        v-if="isAuthenticated"
        id="ddown-divider"
        variant="primary"
        class="user-drop-btn d-flex align-items-center justify-content-between"
      >
        <template slot="button-content">
          <i class="fas fa-user fa-lg spacer-left user-icon" /><span class="user-name ml-2">{{ userEmail }}</span>
        </template>
        <b-dropdown-item
          class="user-drop-btn logout-btn"
          @click="onSignoutPressed"
        >
          Logout
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import Amplify from 'aws-amplify'

export default {
  name: 'Header',
  data: function () {
    return {
      clientSelected: true,
      authState: 'unauthenticated'
    }
  },
  computed: {
    userEmail() {
      return this.$store.state.auth.userEmail
    },
    clientSaved() {
      return this.$store.state.client.clientSelected
    },
    isAuthenticated() {
      return this.$store.state.auth.authState === 'authenticated'
    },
    displayClientMsg() {
      return this.$router.currentRoute.path !== '/payments'
    }
  },
  methods: {
    navigateToClientSelection() {
      this.$router.push({ name: 'client' })
    },
    async onSignoutPressed() {
      this.$store.dispatch('clearAll').then(async () => {
        // this.$router.push({ name: 'login' })
        try {
          await Amplify.Auth.signOut()
          await this.$store.dispatch('auth/setAuthState', 'unauthenticated')
          await this.$router.replace({ name: 'login' })
          // TODO
          // Set state in vue store to unathenticated
        } catch (err) {
          console.error(`onSignoutPressed: err = ${err}`)
          this.$router.push({ name: 'login' })
        }
      })
    },
    logout() {
      this.$store.dispatch('clearAll')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/header.scss';
</style>


